import React, { useState } from 'react';
import {
  Box,
  Button,
  Divider,
  IconButton,
  Icons,
  Modal,
  Text,
  useTheme,
} from '@ublend-npm/aulaui-core';
import NavigationBackHeader from '@app/components/presentational/common/NavigationBackHeader/NavigationBackHeader';
import {
  ALERT_CANCEL_BUTTON_TEXT,
  ALERT_CONFIRM_BUTTON_TEXT,
  ALERT_MESSAGE,
  ALERT_TITLE,
  POST,
  SAVE,
} from '../text';
import { createStyles } from './PostMobileWrapper.styles';

export type PostMobileWrapperProps = {
  mode: 'create' | 'edit';
  children: React.ReactNode;
  onBack?: () => void;
  onSubmit: () => void;
  loading: boolean;
  submitDisabled: boolean;
  showUnsavedChangesAlert?: boolean;
};

const PostMobileWrapper = ({
  mode,
  children,
  onBack,
  onSubmit,
  loading,
  submitDisabled,
  showUnsavedChangesAlert = false,
}: PostMobileWrapperProps) => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const [showAlert, setShowAlert] = useState<boolean>(false);

  // handle back button
  const handleBack = () => {
    if (showUnsavedChangesAlert) {
      setShowAlert(true);
    } else {
      onBack?.();
    }
  };

  return (
    <Box sx={styles.mobileContentWrapper}>
      <AlertModal
        open={showAlert}
        onClose={() => setShowAlert(false)}
        onConfirm={() => {
          setShowAlert(false);
          onBack?.();
        }}
      />
      <Box sx={styles.mobileHeader}>
        <NavigationBackHeader onClick={handleBack} />
        <Box sx={styles.mobileHeaderRightEnd}>
          {/* TODO: Schedule post */}
          <IconButton onClick={() => {}} aria-label="Schedule post">
            <Icons.Schedule />
          </IconButton>
          <Button
            sx={styles.mobileButtonSx}
            kind="primary"
            type="button"
            loading={loading}
            onClick={onSubmit}
            disabled={submitDisabled}
          >
            {/* Both label and loader are overlapped when loading is true. to fix it */}
            {loading ? '' : mode === 'create' ? POST : SAVE}
          </Button>
        </Box>
      </Box>

      <Divider sx={{ my: '10px' }} />
      <Box sx={styles.mobileEditor}>{children}</Box>
    </Box>
  );
};

export default PostMobileWrapper;

const AlertModal = ({
  open,
  onClose,
  onConfirm,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="post-leave-alert-title"
    >
      <Box sx={styles.alertContainer}>
        <Box sx={styles.alertHeader}>
          <Text id="post-leave-alert-title" sx={styles.alertTitle}>
            {ALERT_TITLE}
          </Text>
          <IconButton
            aria-label="Close"
            onClick={onClose}
            sx={styles.alertClose}
          >
            <Icons.Close />
          </IconButton>
        </Box>
        <Text sx={styles.alertMessage}>{ALERT_MESSAGE}</Text>
        <Box sx={styles.alertFooter}>
          <Button
            kind="secondary"
            type="button"
            onClick={onClose}
            sx={styles.alertButton}
          >
            {ALERT_CANCEL_BUTTON_TEXT}
          </Button>
          <Button
            kind="primary"
            type="button"
            onClick={onConfirm}
            sx={styles.alertButton}
          >
            {ALERT_CONFIRM_BUTTON_TEXT}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
